<section>
  <div (click)="resetCounter()">
    <div [style.background-color]="`rgba(255,0,0,${indicatorOpacity})`" class="indicator">CD Indicator ({{ indicatorCounter }})</div>
  </div>
</section>

<section>
  <button mat-raised-button (click)="timeChangeDetection(doProfile.checked)">Time Change Detection</button>
  <mat-checkbox #doProfile>Save JS Profile</mat-checkbox>
  <mat-checkbox [checked]="logCDDetails" (change)="logCDDetails = !logCDDetails">Detailed CD Logs</mat-checkbox>

  <div class="cd-profile-result mat-small">
    @if (cdRuns !== -1) {
      <div>Runs: {{ cdRuns }}</div>
    }
    @if (avgCdTime !== -1) {
      <div>Avg Time: {{ avgCdTime | number: '1.0-2' }}ms</div>
    }
  </div>
</section>

<section>
  <button mat-raised-button (click)="profileActiveRoute()">Profile current route</button>
</section>
